// extracted by mini-css-extract-plugin
export var filterIncDec = "_d5-0";
export var leftBorder = "_d5-1";
export var rightBorder = "_d5-2";
export var stringInput = "_d5-3";